<template>
  <hic-dialog append-to-body :title="title" :visible="visible" @close="cancel" width="70rem" @open="open" :close-on-click-modal="false">
    <el-form v-loading="meta.loading" :model="infoDetail" :rules="comRules" ref="submitForm" label-width="7rem" label-position="right" style="padding-right: 3rem">
      <el-row>
        <el-col :span="8">
          <el-form-item label="名称" prop="name">
            <el-input size="small" type="text" placeholder="请输入名称" v-model.trim="infoDetail.name" />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="编码" prop="code">
            <el-input size="small" type="text" placeholder="请输入编码" v-model.trim="infoDetail.code"></el-input>
          </el-form-item>
        </el-col>

        <el-col :span="8">
          <el-form-item label="助记码" prop="shortCode">
            <el-input size="small" type="text" placeholder="请输入助记码" v-model.trim="infoDetail.shortCode"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="规格" prop="">
            <el-input size="small" type="textarea" placeholder="请输入规格" v-model.trim="infoDetail.standard"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="分类" prop="type">
            <hic-dict-selector dict-type="NursingItemType" is-enum placeholder="请选择分类" v-model="infoDetail.type" />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="费用标准" prop="">
            <el-select size="small" v-model="infoDetail.standardCode" clearable filterable placeholder="请选择费用标准" @change="seleFee">
              <el-option v-for="item in feeStandList" :key="item.id" :label="item.name" :value="item.code"> </el-option>
            </el-select>
            <!-- <hic-dict-selector dict-type="NursingItemType" placeholder="费用标准"
                            v-model="infoDetail.standardCode" /> -->
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="费用标准分类" prop="">
            <hic-dict-selector dict-type="StandardClass" placeholder="请选择费用标准分类" v-model="infoDetail.standardClass" />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="单价" prop="price">
            <el-input size="small" type="text" placeholder="请输入单价" v-model.trim="infoDetail.price"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <!-- {{ dict.DrugUnit }} -->
          <el-form-item label="单位" prop="">
            <!-- <el-select size="small" v-model="infoDetail.unit" clearable placeholder="请选择单位">
              <el-option v-for="item in dict.DrugUnit" :key="item.id" :label="item.name" :value="item.name"> </el-option>
            </el-select> -->
            <hic-text-selector dict-type="DrugUnit" placeholder="请选择单位" v-model="infoDetail.unit" />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="财务分类" prop="">
            <hic-dict-selector dict-type="StandardFeeClass" placeholder="请选择财务分类" v-model="infoDetail.feeClass" />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="医保类别" prop="">
            <hic-dict-selector dict-type="ReimburseCategory" placeholder="请选择医保类别" v-model="infoDetail.insuranceClass" />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="工伤险类别" prop="">
            <hic-dict-selector dict-type="ReimburseCategory" placeholder="请选择工伤险类别" v-model="infoDetail.injuryClass" />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="性别限制" prop="">
            <hic-dict-selector dict-type="Gender" placeholder="请选择性别" v-model="infoDetail.gender" />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="最小年龄" prop="">
            <el-input size="small" type="text" placeholder="请输入最小年龄" v-model.trim="infoDetail.ageMin"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="最大年龄" prop="">
            <el-input size="small" type="text" placeholder="请输入最大年龄" v-model.trim="infoDetail.ageMax"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="备注" prop="">
            <el-input size="small" type="textarea" placeholder="请输入备注" v-model.trim="infoDetail.memo"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button type="info" @click="cancel">关 闭</el-button>
      <el-button type="primary" @click="save">提 交</el-button>
    </div>
  </hic-dialog>
</template>

<script>
  import api from "./api";
  import { mapGetters } from "sw-hic";
  export default {
    props: {
      title: String,
      visible: Boolean,
      infoDetail: Object,
      feeStandList: Array,
    },
    data() {
      var price = (rule, value, callback) => {
        var priceReg = /^(([1-9][0-9]*)|(([0]\.\d{1,2}|[1-9][0-9]*\.\d{1,2})))$/;
        if (!priceReg.test(value)) {
          callback(new Error("请输入正确的价格"));
        } else {
          callback();
        }
      };
      return {
        meta: {
          loading: false,
        },
        comRules: {
          name: [{ required: true, message: "请输入名称", trigger: "blur" }],
          code: [{ required: true, message: "请输入编码", trigger: "blur" }],
          shortCode: [{ required: true, message: "请输入助记码", trigger: "blur" }],
          type: [{ required: true, message: "请选择分类", trigger: "change" }],
          price: [
            { required: true, message: "请输入价格", trigger: "blur" },
            { validator: price, trigger: "blur" },
          ],
        },
      };
    },
    computed: {
      ...mapGetters(["dict", "user", "dictEnum", "Enum"]),
    },
    created() {},
    methods: {
      seleFee(val) {
        let _obj = this.feeStandList.find((el) => {
          return el.code == val;
        });
        this.$set(this.infoDetail, "standardName", _obj.name);
        debugger;
      },
      open() {},
      cancel() {
        this.$emit("update:visible", false);
        this.$emit("cancel");
      },
      save() {
        this.$refs.submitForm.validate().then((valid) => {
          if (valid) {
            this.meta.loading = true;
            // if(this.title.indexOf('新增')>-1) {
            //     this.$set(this.infoDetail,'ifDetail',false)
            // }
            api.NursingItem.save(this.infoDetail)
              .then((res) => {
                this.$message.success("保存成功!");
                this.$emit("close");
                this.cancel();
              })
              .catch((err) => {
                this.$message.error(err);
              })
              .finally(() => {
                this.meta.loading = false;
              });
          }
        });
      },
    },
  };
</script>
